import {
    OrderingListViewModel, OrderingListItemViewModel,
    RemoveItemFromOrderingListCommand, UpdateOrderingListCommand, AddItemToOrderingListCommand,    
    CreateOrderingListCommand, DeleteOrderingListCommand, UpdateIsActiveOnOrderingListItemCommand, UpdateIsAvailableOnOrderingListItemCommand,
    UpdateIsDeletedOnOrderingListItemCommand
} from "Api/CoreApi"
import { defineModule } from "direct-vuex"
import store, { moduleActionContext, moduleGetterContext } from "."
import ApiServices from "Api/ApiFactory";
import ApiFactory from "Api/ApiFactory";
import ProductListHelper from "Helpers/ProductListHelper";

export interface IOrderingListFilter{
    showFilter: boolean;
    showFromMasterList: boolean;
}

export interface IOrderingListsState {
    currentProductKey : string;
    currentOrderingList: OrderingListViewModel,
    showMenu: boolean;
    orderingLists: OrderingListViewModel[];
    detectChanges: boolean;
    isLoading: boolean;
    error: boolean;
    buildList: boolean;
    filter: IOrderingListFilter;
    scopeIsFromShop: boolean;
    userIdentity: string;
}

const initial: IOrderingListsState = {
    currentProductKey: null,
    currentOrderingList: null,
    showMenu: null,
    orderingLists: [],
    error: false,
    isLoading: false,
    //hack to trigger re-rendering of component - just use it in a getter and flip it
    detectChanges: null,
    buildList :false,
    filter: {
        showFilter: false,
        showFromMasterList: false
    },
    scopeIsFromShop: false,
    userIdentity: ''
}


let filterPromise: Promise<any>;

//TODO: mso - change whole implementatoin
let promise: Promise<any>;
let masterPromise: Promise<any>;

const orderingList = defineModule({
    namespaced: true,
    state: (): IOrderingListsState => {
        return initial;
    },
    getters: {
        orderingLists(...args): OrderingListViewModel[] {
            const { state, getters, rootState, rootGetters } = mod1GetterContext(args);
            return state.orderingLists;
        },
        isUserAdvancedAdmin(...args): boolean{
            const { state, getters, rootState, rootGetters } = mod1GetterContext(args);
            const user = rootState.auth.user;
            if(user && user.roles)
            {
                return user.roles.includes('AdminAdvanced');
            }
            return false;
        },
        isUserAdvanced(...args): boolean{
            const { state, getters, rootState, rootGetters } = mod1GetterContext(args);
            const user = rootState.auth.user;
            if(user && user.roles)
            {
                return user.roles.includes('Advanced');
            }
            return false;
        },
        isEmployee(...args): boolean{
            const { state, getters, rootState, rootGetters } = mod1GetterContext(args);
            const user = rootState.auth.user;
            if(user && user.roles)
            {
                return user.roles.includes("Employee");
            }
            return false;
        },
        filter(...args): IOrderingListFilter{
            const { state, getters, rootState, rootGetters } = mod1GetterContext(args);
            return state.filter;
        }
        
        
    },
    mutations: {
        SET_CURRENT_LIST(state, list: OrderingListViewModel){
            state.currentOrderingList = list;
        },
        SET_LISTS(state, lists: OrderingListViewModel[]) {
            state.detectChanges = !state.detectChanges;
            state.orderingLists = lists;
        },
        ADD_LIST(state, list: OrderingListViewModel) {
            state.orderingLists.push(list);
        },
        DELETE_LIST(state, list:DeleteOrderingListCommand) {
            //TODO- this is not working!!
            state.orderingLists = state.orderingLists.filter(x => x.id !== list.id);
        },        
        UPDATE_LIST(state, update: UpdateOrderingListCommand) {
            let list = state.orderingLists.find(x => x.id === update.id);
            list.name = update.name;
            list.budgetPerMonth = update.budget;
            list.listUserPermission.budgetFrequency = update.period;
            list.listUserPermission.unusedBudgetShouldBeTransferredToNextPeriod = update.unusedBudgetShouldBeTransferredToNextPeriod;
            
            state.detectChanges = !state.detectChanges;
        },
        // ADD_ITEM_TO_LIST(state, addItem: AddItemToOrderingListCommand){
        //     state.masterOrderingList.items.push()
        // }
        // DELETE_LISTITEM(state, remove: RemoveItemFromOrderingListCommand) {
        //     var list = state.orderingLists.find(x => x.id === remove.parentId);
        //     if (list) {
        //         list.items = list.items.filter(x => x.id !== remove.id);
        //     }
        // },
        UPDATE_ITEM_ISACTIVE(state, updateItem: UpdateIsActiveOnOrderingListItemCommand)
        {
            state.currentOrderingList.items.find(x => x.productKey == updateItem.productKey).isActive = updateItem.isActive;
        },
        UPDATE_ISAVAILABLE(state, updateItem: UpdateIsAvailableOnOrderingListItemCommand)
        {
            state.currentOrderingList.items.find(x => x.productKey == updateItem.productKey).isAvailable = updateItem.isAvailable;
        },
        UPDATE_ISDELETED(state, updateItem: UpdateIsDeletedOnOrderingListItemCommand) {
            state.currentOrderingList.items.find(x => x.productKey == updateItem.productKey).isDeleted = updateItem.isDeleted;
        },
        SET_FILTER(state, filter: IOrderingListFilter){
            state.filter = filter;
        }
    },
    actions: {
        async loadFilter(context) : Promise<any>{
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            
            //load state from cookie or just URL ? (url state, hmm..)
            
            
            return this.filterPromise || (this.filterPromise = new Promise(async (resolve, reject) =>{
                try{
                    const query = new URLSearchParams(window.location.search.toString().toLowerCase());
                    const filter = <IOrderingListFilter>  {
                        showFromMasterList : JSON.parse(query.get('showfrommasterlist'))
                    }
                    commit.SET_FILTER(filter);
                    
                } catch(error){
                    
                }
                resolve();
            }))
        },
        async updateFilter(context, filter: IOrderingListFilter) : Promise<any>{
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            
            
            //cookie SHOULD always be updated from server (for now), cause we are rendering content from server first.
            //modify url with filter and 'reload' implicit
            const query = new URLSearchParams(window.location.search.toString().toLowerCase());
            
            const queryKeys = Array.from(query.keys());
            for(const filterPropName in filter){
                
                // const queryValue = queryKeys.find(x => x.toLowerCase() == filterPropName.toLowerCase());
                // const queryKeyValue = query.get(filterPropName.toLocaleLowerCase())
                // if(queryKeyValue){

                // }

                query.set(filterPropName.toLowerCase(), (<any>filter)[filterPropName]);
                
            }
            
            // localStorage.setItem("orderinglist_filter", JSON.stringify(filter));
            
            //implicit reload page - DO NOT reload page, this will force to previous location state
            window.location.search = query.toString();
            
            
            // window.history.replaceState(null,'',);
            // window.location.reload();
            
            // commit.SET_FILTER(filter);
        },
        async loadOrderingLists(context, force : boolean) : Promise<any> {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            
            if(force) promise = null;
            
            return promise ||(promise = new Promise(async (resolve, reject) => {
                let client = await ApiFactory.getOrderingListClient();
                let response = await client.getListDetails(false, state.userIdentity);
                commit.SET_LISTS(response.orderingLists);
                resolve();
            }));
            
        },
        async loadMasterList(context, force: boolean) : Promise<any> {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            if(force) masterPromise = null;
            
            //wait for filter state is loaded
            await this.filterPromise;
            
            return masterPromise ||(masterPromise = new Promise(async (resolve, reject) => {
                let client = await ApiFactory.getOrderingListClient();
                let productKeys = await ProductListHelper.GetAllProductKeys();
                let response = await client.getMasterList(productKeys, state.filter?.showFromMasterList);
                commit.SET_CURRENT_LIST(response.masterList);
                resolve();
            }));
            
        },
        async loadOrderingListById(context, payload: {force: boolean, buildList: boolean, id: string, scopeIsFromShop:boolean}) : Promise<any> {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            if(payload.force) masterPromise = null;
            
            //wait for filter state is loaded
            await this.filterPromise;
            
            return masterPromise ||(masterPromise = new Promise(async (resolve, reject) => {
                let client = await ApiFactory.getOrderingListClient();
                let productKeys = await ProductListHelper.GetAllProductKeys();
                let response = await client.getById(payload.id, productKeys, state.filter?.showFromMasterList ?? payload.scopeIsFromShop);
                
                state.buildList = payload.buildList;
                state.scopeIsFromShop = payload.scopeIsFromShop;
                commit.SET_CURRENT_LIST(response.orderingList);
                resolve();
            }));
        },
        async loadEmployeeOrderingLists(context) : Promise<any> {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            return promise ||(promise = new Promise(async (resolve, reject) => {
                let client = await ApiFactory.getOrderingListClient();
                let response = await client.getListDetails(true, state.userIdentity);
                commit.SET_LISTS(response.orderingLists);
            }));
        },
        async updateOrderingList(context, update: UpdateOrderingListCommand) {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getOrderingListClient();
            await client.update(update);
            //TODO: add exception handling?
            commit.UPDATE_LIST(update);
        },
        async createOrderingList(context, create: CreateOrderingListCommand) {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getOrderingListClient();
            await client.create(create);
            //TODO: make controller return new Favoritelist and use mutation instead
            dispatch.loadOrderingLists(true);
        },
        async deleteOrderingList(context, del: DeleteOrderingListCommand) {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getOrderingListClient();
            await client.delete(del);
            //commit.DELETE_LIST(del);
            dispatch.loadOrderingLists(true);
        },
        async addItemOnOrderingList(context, addItem: AddItemToOrderingListCommand){
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getOrderingListClient();
            await client.addItem(addItem);
            //TODO: make controller return new Item and use mutation instead
            dispatch.loadMasterList(true);
        },
        async removeItemOnOrderingList(context, removeItem: RemoveItemFromOrderingListCommand){
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getOrderingListClient();
            await client.removeItem(removeItem);
            // commit.DELETE_LISTITEM(removeItem);
            //TODO: make controller return new Item and use mutation instead
            dispatch.loadMasterList(true);
        },
        // async updateIsActive(context, updateItem: UpdateIsActiveOnOrderingListItemCommand )
        // {
        //     const { dispatch, commit, getters, state } = mod1ActionContext(context);
        //     let client = await ApiFactory.getOrderingListClient();
        //     await client.updateIsActive(updateItem);
        //     if(state.buildList){
        //         await dispatch.loadOrderingListById({
        //             force: true,
        //             buildList: state.buildList,
        //             id : state.currentOrderingList.id
        //         });
        //     }else{
        //         commit.UPDATE_ITEM_ISACTIVE(updateItem);
        //     }
            
            
        // },
        async updateIsAvailable(context, updateItem: UpdateIsAvailableOnOrderingListItemCommand )
        {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getOrderingListClient();
            await client.updateIsAvailable(updateItem);
            if(state.buildList){
                await dispatch.loadOrderingListById({
                    force: true,
                    buildList: state.buildList,
                    id : state.currentOrderingList.id,
                    scopeIsFromShop : state.scopeIsFromShop
                });
            }else{
                commit.UPDATE_ISAVAILABLE(updateItem);
            }
            
            
        },
        async updateIsDeleted(context, updateItem: UpdateIsDeletedOnOrderingListItemCommand) {
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getOrderingListClient();
            await client.updateIsDeleted(updateItem);
            if (state.buildList) {
                await dispatch.loadOrderingListById({
                    force: true,
                    buildList: state.buildList,
                    id: state.currentOrderingList.id,
                    scopeIsFromShop: state.scopeIsFromShop
                });
            } else {
                commit.UPDATE_ISDELETED(updateItem);
            }


        },
        async updateSelectedList(context, listInfo: OrderingListViewModel){
            const { dispatch, commit, getters, state } = mod1ActionContext(context);
            let client = await ApiFactory.getDynamicwebClient();
            await client.setSelectedList(listInfo.id, listInfo.userIsolationKey);
        },
    }
});

export default orderingList;
const mod1GetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, orderingList);
const mod1ActionContext = (context: any) => moduleActionContext(context, orderingList);
